import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from "@angular/core";
import { ActionInterface, ActionReturned } from "../../data/actions-data";

@Component({
  selector: "app-drop-zone-options",
  templateUrl: "./drop-zone-options.component.html",
})
export class DropZoneOptionsComponent implements OnInit {
  @Input() j: number;
  @Input() options: ActionInterface[];
  @Input() value: string | null;
  @Input() isLoading: boolean | null = false;
  @Input() IndexJ : number;
  @Input() isGroupButton: boolean | null = false;
  @Output() optionSelected = new EventEmitter<ActionReturned>();
  @Output() menuOpened = new EventEmitter();

  @ViewChildren('dropDownOptionsMenu') menu: QueryList<ElementRef>;

  showOption: boolean[] = [false];
  i: number;
  constructor(private cdr : ChangeDetectorRef) {}
  option: string;
  ngOnInit(): void {}
  openOptions(j: number, event: Event) {
    this.showOption[j] = !this.showOption[j];
    this.menuOpened.emit(this.value);
    setTimeout(() => {
      if (this.showOption[j] && this.menu) {
        const toggleElement = event.target as HTMLElement
        const rect = toggleElement.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const menuEl = this.menu.first.nativeElement;
        const menuHeight = menuEl.getClientRects()[0].height;
        if (spaceBelow > menuHeight) {
          menuEl.style.top = `${rect.bottom + 10}px`;
          
        } else {
          menuEl.style.top = `${rect.top - menuHeight - 20}px`
        }

        if(this.isGroupButton) {
          menuEl.style.left = `${rect.x}px`;
        }
        
        menuEl.style.width = "fit-content";
        menuEl.style.zIndex = "4";
        
      }
    });

  }
  onClickEmitOption(option: ActionInterface, value: any) {
    this.optionSelected.emit({ option: option, value: value });
  }
  public onOutsideClick(event: any, j: number): void {
    this.showOption[j] = false;
    this.cdr.detectChanges()
  }

  
}
